import { render, staticRenderFns } from "./CheckoutPaymentButtons.vue?vue&type=template&id=d8e95b9c"
import script from "./CheckoutPaymentButtons.vue?vue&type=script&lang=js"
export * from "./CheckoutPaymentButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports